module.exports = __webpack_public_path__ + "assets/img/Tameria_Robinson-Office_Manager.a433c450.jpg";